const marketingRecurringServiceKeys = [
    'marketing_meta_ads',
    'marketing_google_ads',
    'marketing_social_media_management',
    'marketing_tiktok_ads',
    'marketing_email_marketing',
    'marketing_blog'
];

const marketingOneOffServiceKeys = [
    'marketing_email journey',
    'marketing_profile creation'
];

const marketingServiceKeys = [
    ...marketingRecurringServiceKeys,
    ...marketingOneOffServiceKeys
];

export const creative_service_is_locked = (serviceKey = '') => {
    return serviceKey.startsWith('graphic_') || serviceKey.startsWith('creative_');
};

export const creative_fixed_one_off_value = (serviceKey = '') => {
    if (creative_service_is_locked(serviceKey)) {
        return true;
    }

    return null;
};

export const marketing_service_is_locked = (serviceKey = '') => {
    return marketingServiceKeys.includes(serviceKey);
};

export const marketing_fixed_one_off_value = (serviceKey = '') => {
    if (marketingRecurringServiceKeys.includes(serviceKey)) {
        return false;
    }

    if (marketingOneOffServiceKeys.includes(serviceKey)) {
        return true;
    }

    return null;
};

export const service_price_value = (serviceKey = '', defaultPrice = 0, priceValues = {}) => {
    if (marketing_service_is_locked(serviceKey)) {
        return defaultPrice;
    }

    return priceValues[serviceKey] ?? defaultPrice;
};

export const unlocked_service_values = (values = {}) => {
    return Object.keys(values || {}).reduce((nextValues, serviceKey) => {
        if (marketing_service_is_locked(serviceKey)) {
            return nextValues;
        }

        return {
            ...nextValues,
            [serviceKey]: values[serviceKey]
        };
    }, {});
};

export const unlocked_payment_mode_values = (values = {}) => {
    return Object.keys(values || {}).reduce((nextValues, serviceKey) => {
        if (marketing_service_is_locked(serviceKey) || creative_service_is_locked(serviceKey)) {
            return nextValues;
        }

        return {
            ...nextValues,
            [serviceKey]: values[serviceKey]
        };
    }, {});
};
